export function getContrastYIQ(hexcolor: string): string {
  var r = parseInt(hexcolor.substring(1, 3), 16);
  var g = parseInt(hexcolor.substring(3, 5), 16);
  var b = parseInt(hexcolor.substring(5, 7), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "black.600" : "white";
}

export const getColorScheme = (
  colorScheme:
    | "primary"
    | "secondary"
    | "accent"
    | "muted"
    | "pale"
    | "primary-pale"
    | string,
) => {
  let main = `${colorScheme}.500`;
  let text = `text`;
  let light = `${colorScheme}.400`;
  let dark = `${colorScheme}.500`;
  let tint = `${colorScheme}.100`;
  switch (colorScheme) {
    case "primary":
      main = "teal.500";
      text = "gray.100";
      light = "teal.400";
      dark = "teal.600";
      tint = "teal.100";
      break;
    case "secondary":
      main = "purple.500";
      text = "black.600";
      light = "purple.400";
      dark = "purple.600";
      tint = "purple.100";
      break;
    case "accent":
      main = "yellow.500";
      text = "black.600";
      light = "yellow.300";
      dark = "yellow.600";
      tint = "yellow.100";
      break;
    case "muted":
      main = "gray.300";
      text = "gray.600";
      light = "gray.200";
      dark = "gray.400";
      tint = "gray.100";
      break;
    case "pale":
      main = "gray.200";
      text = "black.500";
      light = "gray.200";
      dark = "gray.900";
      tint = "gray.100";
      break;
    case "primary-pale":
      main = "teal.100";
      text = "black.800";
      light = "teal.100";
      dark = "teal.700";
      tint = "teal.300";
      break;
    case "secondary-pale":
      main = "purple.100";
      text = "black.600";
      light = "purple.100";
      dark = "purple.700";
      tint = "purple.300";
      break;
    case "red":
      main = "red.600";
      text = "white";
      light = "red.300";
      dark = "red.700";
      tint = "red.100";
      break;
  }
  return {
    main,
    text,
    light,
    dark,
    tint,
  };
};
